import React from "react";

interface DefaultTextCellProps {
  text?: any;
  asDiv?: boolean;
}

export const DefaultTextCell: React.FC<DefaultTextCellProps> = ({
  text,
  asDiv = false,
}) => {
  if (text === null || text === undefined || text === "") {
    return <span>-</span>;
  }

  if (Array.isArray(text) || React.isValidElement(text)) {
    return <>{text}</>;
  }

  const content = String(text);
  return asDiv ? <div>{content}</div> : <span>{content}</span>;
};
